import { Route } from 'react-router';
import { ModuleGate } from '../../components/ModuleGate';
import type { BackofficeModule } from '../registry';
import { ChatsPage } from './ChatsPage';

/**
 * Einstiegspunkt des Moduls Webchat im Backoffice (KON-173, Schlüssel `webchat`, siehe docs/webseite.md): die Unterhaltungen mit Besuchern der Webseite unter /chats. Der Eintrag steht
 * in der Abteilung CRM (navigation.ts).
 */
export const webchatModule: BackofficeModule = {
  key: 'webchat',
  path: '/chats',
  nav: [{ label: 'Live Chats', path: '/chats' }],
  routes: <Route path="chats" element={<ModuleGate module="webchat" permission="webchat.read"><ChatsPage /></ModuleGate>} />,
};
